import { ChangeEvent } from 'react';
import HoverButton from './HoverButton';
import InputField from './InputField';
import { useTranslation } from 'react-i18next';

interface HopInputProps {
  Id: number;
  Name: string;
  Weight: number | string;
  Acid: number | string;
  Time: number | string;
  IBU: string;
  removeHop: (id: number) => void;
  handleInputChange: (e: ChangeEvent<HTMLInputElement>, id: number) => void;
}

function HopInput({ Id, Name, Weight, Acid, Time, IBU, removeHop, handleInputChange }: HopInputProps) {
  const { t } = useTranslation();
  return (
    <div className="py-3 border-b border-border last:border-b-0 last:pb-0">
      {/* Mobile */}
      <div className="sm:hidden space-y-2">
        <div className="flex gap-2 items-end">
          <div className="flex-1 min-w-0">
            <InputField
              type="text"
              name="Name"
              value={Name}
              onChange={e => handleInputChange(e, Id)}
              placeholder={t('recipe.hopPlaceholder')}
            />
          </div>
          <div className="w-20 shrink-0">
            <InputField unit="g" name="Weight" value={Weight} step="1" onChange={e => handleInputChange(e, Id)} />
          </div>
          <div className="w-20 shrink-0">
            <InputField unit="min" name="Time" value={Time} step="1" onChange={e => handleInputChange(e, Id)} />
          </div>
        </div>
        <div className="grid grid-cols-3 gap-2">
          <InputField unit="%" name="Acid" value={Acid} onChange={e => handleInputChange(e, Id)} />
          <InputField unit="IBU" value={IBU} readOnly />
          <div className="flex items-end">
            <HoverButton onClick={() => removeHop(Id)} btnClass="btn-danger" hoveredIcon="fa-trash-circle" normalIcon="fa-trash" />
          </div>
        </div>
      </div>
      {/* Desktop */}
      <div className="hidden sm:grid grid-cols-6 gap-2 items-end">
        <InputField type="text" name="Name" value={Name} onChange={e => handleInputChange(e, Id)} placeholder={t('recipe.hopPlaceholder')} />
        <InputField unit="g" name="Weight" value={Weight} step="1" onChange={e => handleInputChange(e, Id)} />
        <InputField unit="%" name="Acid" value={Acid} onChange={e => handleInputChange(e, Id)} />
        <InputField unit="min" name="Time" value={Time} step="1" onChange={e => handleInputChange(e, Id)} />
        <InputField unit="IBU" value={IBU} readOnly />
        <HoverButton onClick={() => removeHop(Id)} btnClass="btn-danger" hoveredIcon="fa-trash-circle" normalIcon="fa-trash" />
      </div>
    </div>
  );
}

export default HopInput;
